import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import { initEcho } from './echo'
import { cartStore } from './stores/cartStore'

import { createI18n } from 'vue-i18n'
import en from './locales/en.json'
import ar from './locales/ar.json'

const messages = {
  en: en,
  ar: ar
}
const i18n = createI18n({
  legacy: false,
  globalInjection: true,
  locale: localStorage.getItem('lang_code') || 'ar',
  fallbackLocale: 'en',
  messages
})

const token = localStorage.getItem('access_token')
if (token) {
  window.Echo = initEcho(token)
}

const app = createApp(App)
app.use(router)
app.use(i18n)
app.provide('cartStore', cartStore)
app.mount('#app')
